import type { CardMessageType } from '@/lib/types'

/**
 * Single source of truth for outbound cross-frame messages. The base shape is
 * `{ type }`. Pass `extra` to merge additive fields into the message (e.g.
 * `cardholderName` on `card-payment-completed`). Extra is only used on
 * /hpp-session; all other call sites pass no extra and stay payload-free.
 * See specs/app/index.md::Cross-frame protocol for the full contract.
 */
export function postToHost(type: CardMessageType, extra?: Record<string, unknown>): void {
  window.parent.postMessage({ ...extra, type }, '*')
}

/**
 * Submit button labels — extracted as constants so JET-1758's
 * `paymentButtonLabel` override is a one-prop change at the call site
 * without touching the route bodies.
 */
export const SUBMIT_LABEL_PAYMENT = 'Submit Payment'
export const SUBMIT_LABEL_TOKENIZATION = 'Add Card'
